import { apiGet, apiPatch } from './client';
import type { Asset, AssetBatchRequest } from '../types/Asset';

export function getAssets(): Promise<Asset[]> {
  return apiGet<Asset[]>('/api/assets');
}

export function getAsset(id: number): Promise<Asset> {
  return apiGet<Asset>(`/api/assets/${id}`);
}

export function saveAssetsBatch(
  added: Asset[],
  modified: Asset[],
  deletedIds: number[],
): Promise<Asset[]> {
  return apiPatch<AssetBatchRequest, Asset[]>('/api/assets/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
